import SellingPlanGroup from "./SellingPlanGroup";
import { SellingPlanGroupCatalogInterface } from "./SellingPlanGroupCatalogInterface";
import { SellingPlanGroupInterface } from "./SellingPlanGroupInterface";

import { IPurchasable } from "../Purchasable";
import { ISmartrrSellingPlanGroup } from "./index";

export class SellingPlanGroupCatalog implements SellingPlanGroupCatalogInterface {
  readonly #groups: SellingPlanGroupInterface[];

  private constructor(groups: SellingPlanGroupInterface[]) {
    this.#groups = groups;
  }

  public static fromSellingPlanGroupRecords(
    sellingPlanGroups: ISmartrrSellingPlanGroup[]
  ): SellingPlanGroupCatalog {
    return new SellingPlanGroupCatalog(sellingPlanGroups.map(group => new SellingPlanGroup(group)));
  }

  get #visibleGroups(): SellingPlanGroupInterface[] {
    return this.#groups.filter(group => group.isVisible());
  }

  public findEligiblePurchasable(purchasables: IPurchasable[]): IPurchasable | undefined {
    return purchasables.find(purchasable => this.#visibleGroups.some(group => group.coversProduct(purchasable)));
  }

  public findEligibleProductHandle(purchasables: IPurchasable[]): string | undefined {
    const purchasable = this.findEligiblePurchasable(purchasables);
    if (!purchasable) {
      return undefined;
    }

    return this.#visibleGroups.map(group => group.getHandleForProduct(purchasable)).find(handle => !!handle);
  }
}
